import React, { useEffect, useRef } from 'react';
import SimpleHero from '../../components/SimpleHero/SimpleHero';
import FeatureList from '../../components/Minimal/FeatureList';
import bank from '../../assets/images/security.png'
import './Privacy.css';
import "../../screen/Terms/Termsofuse.css";
import './Privacy.css';
const PRINT_STYLES = `
  * { box-sizing: border-box; }
  body { margin: 0; padding: 18px 20px; font-family: system-ui, -apple-system, sans-serif; font-size: 14px; color: #111; line-height: 1.5; }
  .privacy-hide-in-pdf, .privacy-no-print { display: none !important; }
  h1 { font-size: 1.5rem; font-weight: 700; margin: 0 0 1rem 0; padding-bottom: 0.75rem; border-bottom: 1px solid #333; }
  h4 { font-size: 1.1rem; font-weight: 700; margin: 1.25rem 0 0.5rem 0; color: #111; }
  p { margin: 0 0 0.75rem 0; }
  ul { margin: 0 0 0.75rem 0; padding-left: 1.5rem; }
  li { margin-bottom: 0.35rem; }
  table { width: 100%; border-collapse: collapse; margin: 1rem 0; font-size: 0.9rem; }
  th, td { border: 1px solid rgba(0,0,0,0.2); padding: 10px 12px; text-align: left; vertical-align: top; }
  th { background: #821111; color: #fff; font-weight: 700; }
  tbody tr:nth-child(even) { background: #f5f7f8; }
  a { color: #111; text-decoration: underline; }
  .gn-container { max-width: 100%; padding: 0; }
  .terms-section, .terms-privacy-disclosures { margin-bottom: 1rem; }
  @page { size: A4; margin: 15mm; }
`;

const Privacy = () => {
  const printRef = useRef(null);


  const handlePut = () => {

     window.open('https://portal.gnbank.net', '_blank');
  }

  useEffect(() => {
    document.body.classList.add('privacy-print-page');
    return () => document.body.classList.remove('privacy-print-page');
  }, []);

  const handlePrint = () => {
    if (!printRef.current) return;
    const content = printRef.current.innerHTML;
    const win = window.open('', '_blank');
    if (!win) {
      window.print();
      return;
    }
    win.document.write(
      '<!DOCTYPE html><html><head><meta charset="utf-8"><title>Privacy Disclosures – GN Bank</title><style>' +
      PRINT_STYLES +
      '</style></head><body><div class="privacy-print-body">' +
      content +
      '</div></body></html>'
    );
    win.document.close();
    win.focus();
    setTimeout(() => {
      win.print();
      try { win.onafterprint = () => win.close(); } catch (_) {}
      setTimeout(() => win.close(), 800);
    }, 250);
  };

  return (
    <div className="privacy-page">
      <div className="privacy-no-print">
        <SimpleHero
        title="Your privacy, protected"
        subtitle="We collect only what’s needed, protect it with modern security, and give you control over how it’s shared."
        primaryLabel="Contact privacy"
        primaryHref="/contact"
        variant="sofi"
        imageSrc={bank}
        imageAlt="Security"
        imageOn="right"
        tiltImage
        badges={["Data minimization","Security‑first","Your choices"]}
      />
      <FeatureList
        items={[
          { title: 'Data minimization', desc: 'Only the info required to provide services.' },
          { title: 'Security‑first', desc: 'Encryption, monitoring, and access controls.' },
          { title: 'Your choices', desc: 'Manage communications and sharing preferences.' },
        ]}
      />
        <div className="gn-container privacy-pdf-actions">
          <button type="button" className="btn btn-gn-primary" onClick={handlePrint} aria-label="Download Privacy as PDF">
            Download as PDF
          </button>
          <p className="privacy-pdf-tip small text-muted mt-2 mb-0">
            For a clean PDF with no date or URL: in the print dialog, turn off <strong>Headers and footers</strong>.
          </p>
        </div>
      </div>

      <section ref={printRef} className="section text-center privacy-print-body">
      <h1 className="privacy-pdf-doc-title">Privacy Disclosures</h1>
<div className="gn-container">

  <p className="" style={{textAlign: "right"}}>REV. {new Date().getFullYear()}</p>
<div className="terms-section terms-privacy-disclosures">
<table className="terms-table">
  <thead>
    <tr style={{padding: '5px', textAlign: 'left'}}>
      <th>FACTS.</th>
    </tr>
   
    </thead>

   
  <tbody> 
    <tr style={{textAlign: "left"}}>
      <td style={{padding: '5px'}}>WHAT DOES GN BANK DO WITH YOUR PERSONAL INFORMATION?</td>
    </tr>
  </tbody>
</table>
     
           





             <div className="terms-section">

             


<table className="terms-table">
  <thead>
   <tr></tr>
    </thead>

  <tbody> 
    <tr style={{textAlign: "left"}}>
      <td style={{padding: '5px'}}>WHY </td>

      <td><p>Financial companies choose how they share your pesonal information.  Federal law gives consumers the right to limit some but not all sharing.  Federal law also requires us to tell you how we collect, share, and protect your personal information.  Please read this notice carefully to understand what we do. </p></td>
    </tr>






     <tr style={{textAlign: "justify"}}> 
      <th style={{padding: '15px'}}>HOW?</th>

      <td><p>All financial companies need to share customers' personal information to run their everyday business. In the section below, we list the reasons financial companies can share their cusstomers' personal information; the reasons GN Bank chooses to share; and whether you can limit this sharing. </p></td>
    </tr>
 
  </tbody>
</table>
     
              </div>














              <p className="terms-section">



                <table className="terms-table">
  <thead>
    <tr style={{padding: '5px', textAlign: 'left'}}>
      <th>WHAT WE COLLECT</th>
    </tr>

    
    </thead>


  
   
  {/* <tbody> 
    <tr style={{textAlign: "left"}}>
      <td style={{padding: '5px'}}>WHAT DOES GN BANK DO WITH YOUR PERSONAL INFORMATION?</td>
    </tr>
  </tbody> */}
</table>

                The types of personal information we collect and share depend on the product or service you have with us. This information can include:
              </p>
              <ul style={{listStyleType: 'disc', textAlign: 'left'}}>
                <li>Social Security number</li>
                <li>Account balances</li>
                <li>Payment history</li>
                <li>Transactional history</li>
                <li>Credit history</li>
                <li>Wire transfer instructions</li>
              </ul>
              {/* <p>Financial companies choose how they share your personal information. Federal law gives consumers the right to limit some but not all sharing. Federal law also requires us to tell you how we collect, share, and protect your personal information. Please read this notice carefully to understand what we do.</p> */}

              <h4 className="terms-privacy-facts-title">What does GN Bank do with your personal information? Facts</h4>
              <div className="terms-privacy-table">
                <table className="terms-table">
                  <thead>
                    <tr>
                      <th>Reasons we can share your personal information</th>
                      <th>Does GN Bank share?</th>
                      <th>Can you limit this sharing?</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>For our everyday business purposes – such as to process your transactions, maintain your account(s), respond to court orders and legal investigations, or report to credit bureaus</td>
                      <td>Yes</td>
                      <td>No</td>
                    </tr>
                    <tr>
                      <td>For our marketing purposes – to offer our products and services to you</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                    <tr>
                      <td>For joint marketing with other financial companies</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                    <tr>
                      <td>For our affiliates' everyday business purposes – information about your transactions and experiences</td>
                      <td>Yes</td>
                      <td>No</td>
                    </tr>
                    <tr>
                      <td>For our affiliates' everyday business purposes – information about your creditworthiness</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                    <tr>
                      <td>For nonaffiliates to market to you</td>
                      <td>No</td>
                      <td>We don't share</td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div className="terms-privacy-table">
                <table className="terms-table">
                  <thead>
                    <tr>
                      <th>What we do</th>
                      <th></th></tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Who is providing this notice?</td>
                      <td>GN Bank, located in Chicago.</td>
                      
                    </tr>
                    <tr>
                      <td>How does GN Bank
                      protect my personal information?</td>
                      <td>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.
We also maintain other physical, electronic and procedural safeguards to
protect this information and we limit access to information to those
employees for whom access is appropriate. </td>
                      
                    </tr>
                    <tr>
                      <td>How does GN Bank
                      collect my personal information?</td>
                      <td>We collect your personal information, for example, when you
                        <ul>
                          <li>Open an account</li>
                          <li>Apply for a loan</li>
                          <li>Give us your income information</li>
                          <li>Give us your wage statements</li>
                          <li>Make a wire transfer</li>
                          <li>We also collect your personal information from others, such as credit bureaus, affiliates, or other companies.</li>
                        </ul>
                      </td>
                     
                    </tr>
                    <tr>
                      <td>Why can't I limit all sharing?</td>
                      <td>
                        Federal law gives you the right to limit only 
                        <ul>
                          <li>(1) sharing for affiliates' everyday business purposes – information about your creditworthiness;</li>
                          <li>(2) affiliates from using your information to market to you;</li>
                          <li>(3) sharing for nonaffiliates to market to you.</li>
                          <li>State laws and individual companies may give you additional rights to limit sharing.</li>
                        </ul>
                        </td>
                      
                    </tr>
                    {/* <tr>
                      <td>For our affiliates' everyday business purposes – information about your creditworthiness</td>
                      <td>We don't share</td>
                     
                    </tr>
                    <tr>
                      <td>For nonaffiliates to market to you</td>
                      <td>We don't share</td>
                      
                    </tr> */}
                  </tbody>
                </table>
              </div>








{/* 

              <p><strong>Questions?</strong> Call 773-624-2000 or go to <a href="https://www.gnbank.net" rel="noopener noreferrer">www.gnbank.net</a></p>
              <p>When you are no longer a customer, we continue to share your information as described in this notice.</p>
              <p>All financial companies need to share customers' personal information to run their everyday business. In the section below, we list the reasons financial companies can share their customers' personal information; the reasons GN Bank chooses to share; and whether you can limit this sharing.</p> */}

              <h4>Definitions</h4>
              <ul style={{listStyleType: 'disc', textAlign: 'left'}}>
                <li><strong>Affiliates</strong> – Companies related by common ownership or control. They can be financial and nonfinancial companies. Nonfinancial companies such as: GN Bank Safe Deposit Box, Inc. and Metropolitan Service Corporation.</li>
                <li><strong>Nonaffiliates</strong> – Companies not related by common ownership or control. They can be financial and nonfinancial companies.</li>
                <li><strong>Joint marketing</strong> – A formal agreement between nonaffiliated financial companies that together market financial products or services to you.</li>
              </ul>

              {/* <h4>Why can't I limit all sharing?</h4>
              <p>Federal law gives you the right to limit only (1) sharing for affiliates' everyday business purposes – information about your creditworthiness; (2) affiliates from using your information to market to you; (3) sharing for nonaffiliates to market to you. State laws and individual companies may give you additional rights to limit sharing.</p>
              <p>GN Bank does not share with nonaffiliates so they can market to you. GN Bank doesn't jointly market.</p>

              <h4>How does GN Bank collect my personal information?</h4>
              <p>We collect your personal information, for example, when you:</p> */}
              {/* <ul>
                <li>Open an account</li>
                <li>Apply for a loan</li>
                <li>Give us your income information</li>
                <li>Give us your wage statements</li>
                <li>Make a wire transfer</li>
              </ul> */}
              <p>We also collect your personal information from others, such as credit bureaus, affiliates, or other companies.</p>
{/* 
              <h4>How does GN Bank protect my personal information?</h4>
              <p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings. We also maintain other physical, electronic and procedural safeguards to protect this information and we limit access to information to those employees for whom access is appropriate.</p> */}

              {/* <h4>What we do</h4>
              <p>To protect your personal information from unauthorized access and use, we use security measures that comply with federal law. These measures include computer safeguards and secured files and buildings.</p>
              <h4>Who is providing this notice?</h4>
              <p>GN Bank, located in Chicago.</p>
              <h4>Who we are</h4>
              <p>We also maintain other physical, electronic and procedural safeguards to protect this information and we limit access to information to those employees for whom access is appropriate.</p> */}

              <h4>Other Important Information</h4>
              <p><strong>For Alaska, Illinois, Maryland and North Dakota Customers.</strong> We will not share your personal information with nonaffiliates either for them to market to you or for joint marketing – without your authorization.</p>
              <p><strong>For California Customers.</strong> We will not share personal information with nonaffiliates either for them to market to you or for joint marketing – without your authorization. We will also limit our sharing of personal information about you with our affiliates to comply with California privacy laws that apply to us.</p>
              <p><strong>For Massachusetts, Mississippi, and New Jersey Customers.</strong> We will not share personal information from deposit or share relationships with nonaffiliates either for them to market to you or for joint marketing – without your authorization.</p>
              <p><strong>For Vermont Members/Customers.</strong> We will not disclose information about your creditworthiness to our affiliates and will not disclose your personal information, financial information, credit report, or health information to nonaffiliated third parties to market to you, other than as permitted by Vermont law, unless you authorize us to make those disclosures.</p>

              <h4>Questions?</h4>
              <div className="bottom-info-block">Call 773-624-2000 or go to <span className="bottom-info" style={{cursor: 'hand', color: '#af2020'}}  onClick={() => handlePut()}>Customer Support</span></div>
              {/* <div>Call <strong>773-624-2000</strong> or go to <a href="https://www.gnbank.net" style={{textDecoration: 'none', color: '#af2020'}}>www.gnbank.net</a>. Additional information concerning our privacy policies can be found at <a href="https://www.gnbank.net" style={{textDecoration: 'none', color: '#111'}}>www.gnbank.net</a> or call 773-624-2000.</div> */}
              <p className=""><strong>Rev {new Date().getFullYear()}</strong></p>
            </div>

</div>

       

          <a className="btn btn-gn-primary privacy-no-print" href="/contact">Request full policy</a>
      
      </section>
    </div>

  );
};

export default Privacy;
